<template>
  <el-form ref="form" :model="localData" :rules="rules" label-width="160px" size="small">
    <el-form-item label="主体类型" prop="subjectType">
      <el-select v-model="localData.subjectType" placeholder="请选择" style="width:100%">
        <el-option label="企业" value="ENTERPRISE" />
        <el-option label="个体工商户" value="INDIVIDUAL" />
      </el-select>
    </el-form-item>

    <template v-if="localData.subjectType">
      <el-divider>营业执照信息</el-divider>

      <el-form-item label="营业执照" prop="licenseCopyImageId">
        <div class="upload-row">
          <el-input v-model="localData.licenseCopyUrl" placeholder="请点击选择图片按钮选择图片" readonly />
          <el-button type="primary" @click="openImageSelector('licenseCopy')">选择图片</el-button>
        </div>
        <div v-if="localData.licenseCopyUrl" class="image-preview">
          <el-image :src="localData.licenseCopyUrl" class="thumb" fit="cover" />
        </div>
        <div v-if="localData.licenseCopyMediaId" class="media-id-info">
          <span class="media-id-label">微信MediaId:</span>
          <span class="media-id-value">{{ localData.licenseCopyMediaId }}</span>
        </div>
      </el-form-item>

      <el-form-item label="统一社会信用代码" prop="licenseNumber">
        <el-input v-model="localData.licenseNumber" placeholder="18位" maxlength="18" />
      </el-form-item>

      <el-form-item :label="localData.subjectType === 'ENTERPRISE' ? '商户名称' : '经营者姓名'" prop="merchantName">
        <el-input v-model="localData.merchantName" placeholder="与营业执照一致" />
      </el-form-item>

      <el-form-item v-if="localData.subjectType === 'ENTERPRISE'" label="法人姓名" prop="legalPersonName">
        <el-input v-model="localData.legalPersonName" placeholder="法人代表姓名" />
      </el-form-item>

      <el-form-item label="注册地址">
        <el-input v-model="localData.licenseAddress" type="textarea" :rows="2" />
      </el-form-item>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="有效期开始">
            <el-date-picker v-model="localData.licensePeriodBegin" type="date" placeholder="选择" style="width:100%" value-format="yyyy-MM-dd" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="有效期结束">
            <el-date-picker
                v-model="localData.licensePeriodEnd"
                type="date"
                placeholder="留空表示长期有效"
                style="width:100%"
                value-format="yyyy-MM-dd"
                clearable
            />
            <div class="form-tip">留空表示长期有效</div>
          </el-form-item>
        </el-col>
      </el-row>

      <el-divider>法人/经营者证件</el-divider>

      <el-form-item label="身份证号" prop="legalPersonIdCard">
        <el-input v-model="localData.legalPersonIdCard" placeholder="18位身份证号" maxlength="18" />
      </el-form-item>

      <el-form-item label="身份证正面" prop="idCardFrontImageId">
        <div class="upload-row">
          <el-input v-model="localData.idCardFrontUrl" placeholder="请点击选择图片按钮选择图片" readonly />
          <el-button type="primary" @click="openImageSelector('idCardFront')">选择图片</el-button>
        </div>
        <div v-if="localData.idCardFrontUrl" class="image-preview">
          <el-image :src="localData.idCardFrontUrl" class="thumb" fit="cover" />
        </div>
        <div v-if="localData.idCardFrontMediaId" class="media-id-info">
          <span class="media-id-label">微信MediaId:</span>
          <span class="media-id-value">{{ localData.idCardFrontMediaId }}</span>
        </div>
      </el-form-item>

      <el-form-item label="身份证反面" prop="idCardBackImageId">
        <div class="upload-row">
          <el-input v-model="localData.idCardBackUrl" placeholder="请点击选择图片按钮选择图片" readonly />
          <el-button type="primary" @click="openImageSelector('idCardBack')">选择图片</el-button>
        </div>
        <div v-if="localData.idCardBackUrl" class="image-preview">
          <el-image :src="localData.idCardBackUrl" class="thumb" fit="cover" />
        </div>
        <div v-if="localData.idCardBackMediaId" class="media-id-info">
          <span class="media-id-label">微信MediaId:</span>
          <span class="media-id-value">{{ localData.idCardBackMediaId }}</span>
        </div>
      </el-form-item>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="证件有效期开始" prop="idCardPeriodBegin">
            <el-date-picker v-model="localData.idCardPeriodBegin" type="date" placeholder="选择" style="width:100%" value-format="yyyy-MM-dd" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="证件有效期结束" prop="idCardPeriodEnd">
            <el-date-picker
                v-model="localData.idCardPeriodEnd"
                type="date"
                placeholder="留空表示长期有效"
                style="width:100%"
                value-format="yyyy-MM-dd"
                clearable
            />
            <div class="form-tip">留空表示长期有效</div>
          </el-form-item>
        </el-col>
      </el-row>
    </template>

    <div class="module-footer">
      <el-button type="primary" @click="submitModule" :loading="saving">保 存</el-button>
    </div>

    <!-- 图片选择器 -->
    <image-selector
        v-model="showImageSelector"
        :max-count="1"
        @select="handleImageSelect"
    />
  </el-form>
</template>

<script>
import api from '@/utils/api'
import ImageSelector from '@/components/ImageSelector'

export default {
  name: 'SubjectInfo',
  components: { ImageSelector },
  props: {
    data: { type: Object, default: () => ({}) },
    applyId: { type: Number, default: null },
    applyNo: { type: String, default: '' },
    merchantId: { type: Number, default: null }
  },
  data() {
    return {
      saving: false,
      showImageSelector: false,
      currentUploadField: '',
      localData: {
        subjectType: '',
        licenseCopyUrl: '',
        licenseCopyMediaId: '',
        licenseCopyImageId: null,
        licenseNumber: '',
        merchantName: '',
        legalPersonName: '',
        legalPersonIdCard: '',
        licenseAddress: '',
        licensePeriodBegin: '',
        licensePeriodEnd: '',
        idCardFrontUrl: '',
        idCardFrontMediaId: '',
        idCardFrontImageId: null,
        idCardBackUrl: '',
        idCardBackMediaId: '',
        idCardBackImageId: null,
        idCardPeriodBegin: '',
        idCardPeriodEnd: ''
      },
      rules: {
        subjectType: [{ required: true, message: '请选择主体类型', trigger: 'change' }],
        licenseCopyImageId: [{ required: true, message: '请上传营业执照', trigger: 'change' }],
        licenseNumber: [{ required: true, message: '请输入统一社会信用代码', trigger: 'blur' }],
        merchantName: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        licensePeriodBegin: [{ required: true, message: '请选择营业执照有效期开始', trigger: 'change' }],
        legalPersonIdCard: [
          { required: true, message: '请输入身份证号', trigger: 'blur' },
          { pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/, message: '请输入有效的身份证号', trigger: 'blur' }
        ],
        idCardFrontImageId: [{ required: true, message: '请上传身份证正面', trigger: 'change' }],
        idCardBackImageId: [{ required: true, message: '请上传身份证反面', trigger: 'change' }],
        idCardPeriodBegin: [{ required: true, message: '请选择证件有效期开始', trigger: 'change' }]
        // idCardPeriodEnd 不是必填，留空表示长期有效
      }
    }
  },
  watch: {
    data: {
      immediate: true,
      handler(val) {
        if (val && Object.keys(val).length > 0) {
          this.localData = {
            subjectType: val.subjectType !== undefined ? val.subjectType : this.localData.subjectType,
            licenseCopyUrl: val.licenseCopyUrl !== undefined ? val.licenseCopyUrl : this.localData.licenseCopyUrl,
            licenseCopyMediaId: val.licenseCopyMediaId !== undefined ? val.licenseCopyMediaId : this.localData.licenseCopyMediaId,
            licenseCopyImageId: val.licenseCopyImageId !== undefined ? val.licenseCopyImageId : this.localData.licenseCopyImageId,
            licenseNumber: val.licenseNumber !== undefined ? val.licenseNumber : this.localData.licenseNumber,
            merchantName: val.merchantName !== undefined ? val.merchantName : this.localData.merchantName,
            legalPersonName: val.legalPersonName !== undefined ? val.legalPersonName : this.localData.legalPersonName,
            legalPersonIdCard: val.legalPersonIdCard !== undefined ? val.legalPersonIdCard : this.localData.legalPersonIdCard,
            licenseAddress: val.licenseAddress !== undefined ? val.licenseAddress : this.localData.licenseAddress,
            licensePeriodBegin: val.licensePeriodBegin !== undefined ? val.licensePeriodBegin : this.localData.licensePeriodBegin,
            licensePeriodEnd: val.licensePeriodEnd !== undefined ? val.licensePeriodEnd : this.localData.licensePeriodEnd,
            idCardFrontUrl: val.idCardFrontUrl !== undefined ? val.idCardFrontUrl : this.localData.idCardFrontUrl,
            idCardFrontMediaId: val.idCardFrontMediaId !== undefined ? val.idCardFrontMediaId : this.localData.idCardFrontMediaId,
            idCardFrontImageId: val.idCardFrontImageId !== undefined ? val.idCardFrontImageId : this.localData.idCardFrontImageId,
            idCardBackUrl: val.idCardBackUrl !== undefined ? val.idCardBackUrl : this.localData.idCardBackUrl,
            idCardBackMediaId: val.idCardBackMediaId !== undefined ? val.idCardBackMediaId : this.localData.idCardBackMediaId,
            idCardBackImageId: val.idCardBackImageId !== undefined ? val.idCardBackImageId : this.localData.idCardBackImageId,
            idCardPeriodBegin: val.idCardPeriodBegin !== undefined ? val.idCardPeriodBegin : this.localData.idCardPeriodBegin,
            idCardPeriodEnd: val.idCardPeriodEnd !== undefined ? val.idCardPeriodEnd : this.localData.idCardPeriodEnd
          }
        }
      }
    },
    'localData.subjectType'(val) {
      if (val === 'ENTERPRISE') {
        this.rules.legalPersonName = [{ required: true, message: '请输入法人姓名', trigger: 'blur' }]
      } else {
        this.rules.legalPersonName = [{ required: false }]
      }
      this.$nextTick(() => {
        if (this.$refs.form) this.$refs.form.clearValidate()
      })
    }
  },
  methods: {
    // ========== 图片选择 ==========
    openImageSelector(field) {
      this.currentUploadField = field
      this.showImageSelector = true
    },

    async handleImageSelect(images) {
      if (!images || images.length === 0) return

      const image = images[0]
      const imageUrl = image.url
      const imageId = image.id

      const urlField = this.getUrlField(this.currentUploadField)
      const idField = this.getIdField(this.currentUploadField)
      const mediaIdField = this.getMediaIdField(this.currentUploadField)

      if (urlField) this.$set(this.localData, urlField, imageUrl)
      if (idField) this.$set(this.localData, idField, imageId)

      const purpose = this.getPurpose(this.currentUploadField)
      if (purpose && imageUrl) {
        try {
          console.log('获取微信MediaId - imageUrl:', imageUrl, 'purpose:', purpose)
          const res = await api.subMerchant_fetchMediaId({
            imageUrl: imageUrl,
            purpose: purpose
          })
          console.log('fetchMediaId 响应:', res)
          if (res?.data?.code === 200 || res?.data?.success) {
            const data = res.data.data
            const mediaId = data?.media_id || data?.mediaId
            if (mediaId && mediaIdField) {
              this.$set(this.localData, mediaIdField, mediaId)
              console.log('微信MediaId获取成功:', mediaId)
            }
          }
        } catch (e) {
          console.error('获取微信MediaId失败:', e)
        }
      }
    },

    getUrlField(field) {
      return {
        'licenseCopy': 'licenseCopyUrl',
        'idCardFront': 'idCardFrontUrl',
        'idCardBack': 'idCardBackUrl'
      }[field] || ''
    },

    getIdField(field) {
      return {
        'licenseCopy': 'licenseCopyImageId',
        'idCardFront': 'idCardFrontImageId',
        'idCardBack': 'idCardBackImageId'
      }[field] || ''
    },

    getMediaIdField(field) {
      return {
        'licenseCopy': 'licenseCopyMediaId',
        'idCardFront': 'idCardFrontMediaId',
        'idCardBack': 'idCardBackMediaId'
      }[field] || ''
    },

    getPurpose(field) {
      return {
        'licenseCopy': 'business_license_copy',
        'idCardFront': 'id_card_copy',
        'idCardBack': 'id_card_national'
      }[field] || ''
    },

    validate(cb) {
      if (this.$refs.form) this.$refs.form.validate(cb)
      else cb(false)
    },

    toTimestamp(dateStr) {
      if (!dateStr || dateStr === '' || dateStr === null) return null
      if (typeof dateStr === 'number') return dateStr
      const parts = dateStr.split('-')
      if (parts.length === 3) {
        return new Date(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2]), 0, 0, 0, 0).getTime()
      }
      return null
    },

    async submitModule() {
      this.$refs.form.validate(async (valid) => {
        if (!valid) return this.$message.warning('请完善必填信息')
        this.saving = true
        try {
          // ★★★ 身份证有效期结束：空值表示长期 → 传 null ★★★
          // ★★★ 营业执照有效期结束：空值表示长期 → 传 null ★★★
          const params = {
            id: this.applyId,
            applyNo: this.applyNo,
            merchantId: this.merchantId,
            rejectReason: 'subject',
            subjectType: this.localData.subjectType === 'ENTERPRISE' ? 'SUBJECT_TYPE_ENTERPRISE' : 'SUBJECT_TYPE_INDIVIDUAL',
            merchantName: this.localData.merchantName,
            legalPersonName: this.localData.legalPersonName,
            legalPersonIdCard: this.localData.legalPersonIdCard,
            licenseNumber: this.localData.licenseNumber,
            licenseCopyMediaId: this.localData.licenseCopyMediaId,
            licenseCopyImageId: this.localData.licenseCopyImageId,
            licenseAddress: this.localData.licenseAddress,
            licensePeriodBegin: this.toTimestamp(this.localData.licensePeriodBegin),
            licensePeriodEnd: this.toTimestamp(this.localData.licensePeriodEnd),  // null 表示长期
            idCardFrontMediaId: this.localData.idCardFrontMediaId,
            idCardFrontImageId: this.localData.idCardFrontImageId,
            idCardBackMediaId: this.localData.idCardBackMediaId,
            idCardBackImageId: this.localData.idCardBackImageId,
            idCardPeriodBegin: this.toTimestamp(this.localData.idCardPeriodBegin),
            idCardPeriodEnd: this.toTimestamp(this.localData.idCardPeriodEnd)  // null 表示长期
          }

          console.log('========== [SubjectInfo] 提交主体信息 ==========')
          console.log('提交数据:', JSON.stringify(params, null, 2))
          const res = await api.subMerchant_saveApply(params)
          console.log('[SubjectInfo] 响应:', res)
          if (res?.data?.success) {
            this.$emit('saved', res.data.data)
          } else {
            this.$message.error(res?.data?.message || '保存失败')
          }
        } catch (e) {
          console.error('[SubjectInfo] 保存失败:', e)
          this.$message.error('保存失败')
        } finally {
          this.saving = false
        }
      })
    }
  }
}
</script>

<style scoped>
.upload-row { display: flex; gap: 8px; }
.upload-row .el-input { flex: 1; }
.image-preview { margin-top: 8px; }
.thumb { width: 100px; height: 100px; border: 1px solid #eee; border-radius: 4px; object-fit: cover; }
.media-id-info { margin-top: 8px; font-size: 12px; color: #606266; }
.media-id-label { font-weight: 500; color: #909399; }
.media-id-value { margin-left: 8px; color: #67c23a; word-break: break-all; }
.form-tip { font-size: 12px; color: #909399; margin-top: 4px; }
.module-footer { margin-top: 20px; padding-top: 16px; border-top: 1px solid #ebeef5; text-align: right; }
</style>